import { resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isLoaded)
    ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.HIcons[_ctx.convertedName]), {
        key: 0,
        class: _normalizeClass(['inline', {
    'h-4 w-4': _ctx.size === 'small',
    'h-5 w-5': _ctx.size === 'default',
    'h-7 w-7': _ctx.size === 'large'
  }, _ctx.color])
      }, null, 8, ["class"]))
    : _createCommentVNode("", true)
}